import { FC } from 'react'
import s from './index.module.less'
import { Modal } from 'antd'
interface Props {
  visible: boolean
  closeModal: () => void
}
const EquityModal: FC<Props> = (props) => {
  const { visible, closeModal } = props
  return (
    <Modal wrapClassName={s.modal} open={visible} onCancel={closeModal} 
    centered destroyOnClose={true} closable={false} 
    footer={null} mask={false} maskClosable={true}>
      <div className={s.root}>
        <div className='head'>
            <span>更多权益</span>
            <div className='closeBtn' onClick={closeModal}>
                <i className='iconfont icon-lujing3'></i>
            </div>
        </div>
        <div className='content'>
            <div className='equity'></div>
        </div>
        <div className="footer">
            <div className='btn' onClick={closeModal}>开通AI会员</div>
        </div>
      </div>
    </Modal>
  )
}
export default EquityModal
